import {IconName} from '@lightricks/react-design-system';

export interface UserMenuItem {
  id: string;
  labelLocaleKey?: string;
  isDivider?: boolean;
  icon?: IconName;
  link?: string; // For navigation
  onClick?: () => void; // For actions
  children?: UserMenuItem[]; // For nested menus
  external?: boolean; // If true, open in new tab
  testID?: string;
  endIcon?: IconName;
  isDanger?: boolean; // If true, style in danger (red)
}

// Example menu items (replace with real icons and actions as needed)
export const staticUserMenuItems: UserMenuItem[] = [
  // {
  //   id: 'settings',
  //   labelLocaleKey: 'Settings',
  //   icon: 'Navigation-Settings',
  //   link: '/settings',
  // },
  {
    id: 'manage-account',
    labelLocaleKey: 'Manage Account',
    icon: 'Navigation-Profile',
    link: '/account',
  },
  {
    id: 'pricing-and-plan',
    labelLocaleKey: 'Plan & Pricing',
    icon: 'Features-Flash-Active',
    testID: 'pricing-and-plan-menu-item',
  },
  {
    id: 'help-center',
    labelLocaleKey: 'Help center',
    icon: 'Navigation-Question-Line',
    link: 'https://help-popularpays.lightricks.com/hc/en-us/categories/26714624118418-Content-Lab',
    external: true,
  },
  {
    id: 'contact-sales',
    labelLocaleKey: 'Contact Sales',
    icon: 'Navigation-Mail',
  },
  {
    id: 'divider-1',
    isDivider: true,
  },
  {
    id: 'terms-and-policies',
    labelLocaleKey: 'Terms & Policies',
    icon: 'Navigation-Terms',
    children: [
      {
        id: 'terms-and-conditions',
        labelLocaleKey: 'Terms and Conditions',
        link: 'https://static.lightricks.com/legal/ltx-scaler-terms-and-conditions.pdf',
        external: true,
      },
      {
        id: 'sub-divider-1',
        isDivider: true,
      },
      {
        id: 'acceptable-use-policy',
        labelLocaleKey: 'Acceptable Use Policy',
        link: 'https://static.lightricks.com/legal/ltx-acceptable-use-policy.pdf',
        external: true,
      },
      {
        id: 'sub-divider-2',
        isDivider: true,
      },
      {
        id: 'privacy-policy',
        labelLocaleKey: 'Privacy Policy',
        link: 'https://static.lightricks.com/legal/privacy-policy.pdf',
        external: true,
      },
    ],
  },
  {
    id: 'logout',
    labelLocaleKey: 'Log out',
    icon: 'Actions-Logout',
  },
];
